<div class="card">
    <div class="card-header d-flex justify-content-between">
        <h4 class="text-capitalize">{{content.title}}</h4>
        <button type="button" (click)="sidebarService.closeHelp()" class="btn-close" aria-label="Close"></button>
    </div>
    <div class="card-body">
        <ng-template appSidebarContent componentName="content"></ng-template>
    </div>
</div>

